import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { requests } from "../../utils/api/api.service";
import { INCIDENTS_URL, INCIDENT_TYPES_URL, INCIDENT_STATUS_TYPES_URL, INCIDENT_ACTIVITIES_URL } from "../../utils/api/endpoints";
import { IIncident, IIncidentCreate, IIncidentDetails } from "../../shared/interfaces/incident/IIncident";

export const IncidentService = {
  getAll: (params: IPagination): Promise<IBaseModel<IIncident[]>> =>
    requests.get(INCIDENTS_URL, params),
  getSingle: (id: number): Promise<{ data: IIncident }> =>
    requests.get(`${INCIDENTS_URL}/${id}`),
  getDetails: (id: number): Promise<{ data: IIncidentDetails }> =>
    requests.get(`${INCIDENTS_URL}/${id}/detail`),
  create: (payload: IIncidentCreate): Promise<IIncident> =>
    requests.post(INCIDENTS_URL, payload),
  update: (payload: Partial<IIncident>, id?: number): Promise<IIncident> =>
    requests.put(`${INCIDENTS_URL}/${id}`, payload),
  delete: (id: number): Promise<void> =>
    requests.delete(`${INCIDENTS_URL}/${id}`),
  getTypes: (): Promise<{ data: string[] }> =>
    requests.get(INCIDENT_TYPES_URL),
  getStatusTypes: (): Promise<{ data: string[] }> =>
    requests.get(INCIDENT_STATUS_TYPES_URL),
  getActivityContent: (activityId: number): string =>
    `${INCIDENT_ACTIVITIES_URL}/${activityId}/content`,
  deleteActivity: (id: number): Promise<void> =>
    requests.delete(`${INCIDENT_ACTIVITIES_URL}/${id}`),
};
